import { render, staticRenderFns } from "./modal-forgot-password.vue?vue&type=template&id=74e7f878&"
import script from "./modal-forgot-password.vue?vue&type=script&lang=js&"
export * from "./modal-forgot-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports